import { render, staticRenderFns } from "./importTemplateRename.vue?vue&type=template&id=76321db8&scoped=true&"
import script from "./importTemplateRename.vue?vue&type=script&lang=js&"
export * from "./importTemplateRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76321db8",
  null
  
)

export default component.exports